import { useParams } from "react-router-dom";
import { Shimmer } from "./Shimmer";
import { TenantProtectedNotebook } from "./NotebookTabs";



export default function NotebookRouteWrapper({ tenants, user, onLogout }) {
  const { project, section, notebook, page, folder } = useParams();

  // const { data: namespaces, isLoading } = useNamespaces(user?.token);

  // // 1. Loading state (Shimmer)
  // if (isLoading) {
  //   return <Shimmer lines={10} className="full-page-shimmer" />;
  // }

  // 2. Safety check: If user or token is missing, show nothing or a message
  if (!user?.token) {
    return <div>Session expired. Please log in again.</div>;
  }

  return (
    <TenantProtectedNotebook
      tenants={tenants}         // Passed from App.js (user.tenants)
      jwtToken={user.token}     // Using the "Class" token
      user={user}               // 🚀 Pass the whole object too! (Optional but helpful)
      onLogout={onLogout}
      urlProject={project}
      urlSection={section}
      urlNotebook={notebook}
      urlPage={page}
      urlFolder={folder}
    />
  );
}
